import combineReducersNamed from 'common/src/app/util/reducers/combineReducersNamed';
import entityViewReducer from 'common/src/app/reducers/view/entityViewReducer';
import withLoadingCount from 'common/src/app/util/withLoadingCount';
import { PUBLIC_SUCCESS_STORIES_DETAIL } from 'common/src/app/actions/resources/publicActions';

export default combineReducersNamed({
  successStory: withLoadingCount(entityViewReducer, PUBLIC_SUCCESS_STORIES_DETAIL),
});
